import React from "react";
import {
	InputNumber,
	Button,
	Select,
} from "antd";
import Card from "components/card";
import TextArea from "antd/es/input/TextArea";
import { requiredField } from "utils/crudSagaHelper";
import FormItem from "components/fields/FormItem";


const PurchaseOrderItemForm = ({
	field,
	form,
	currency,
	remove,
	mode,
	itemTypeList
}) => {
	const quantity =
		Number(
			form.getFieldValue([
				"items",
				field.name,
				"poi_quantity",
			])
		) || 1;

	const cost =
		Number(
			form.getFieldValue([
				"items",
				field.name,
				"poi_cost",
			])
		) || 0;
		const itemTypeId = form.getFieldValue([
			"items",
			field.name,
			"poi_item_type_id",
		]);

		const itemTypeName =
			itemTypeList?.find(x => x.value === itemTypeId)?.label;
	const total = quantity * cost;

	return (
		<Card className="mb-4 bg-gray-50/30 dark-mode-card border rounded-xl">
			<div className="grid grid-cols-3 gap-6 p-2">
				
				<div className="col-span-2">
					{mode !== "view" ? (

						<FormItem
							name={[field.name, "poi_item_type_id"]}
							label="Item Name"
							rules={[requiredField()]}
						>
								<Select
									className="input-field"
									showSearch
									allowClear
									options={itemTypeList}
								/>
						</FormItem>
					) : (
						<div className="p-2">
							<h2 className="text-sm font-medium muted-text">Item Type</h2>
							<label className="text-base label-value title-text">
								{itemTypeName || "-"}
							</label>
						</div>
					)}

					{mode !== "view" ? (
						<FormItem
							name={[field.name, "poi_description"]}
							label="Description"
						>
								<TextArea
									rows={7}
									className="input-field"
								/>
						</FormItem>
					) : (
						<div className="p-2">
							<h2 className="text-sm font-medium muted-text">Description</h2>
							<label className="text-base label-value title-text">
								{
									form.getFieldValue([
										"items",
										field.name,
										"poi_description",
									])
								}
							</label>
						</div>
					)}
				</div>

				<div className="space-y-2">
						{mode !== "view" ? (
							<FormItem
								name={[field.name, "poi_quantity"]}
								label="Qty"
								initialValue={1}
								rules={[requiredField()]}
							>
									<InputNumber
										min={1}
										className="input-field w-full"
									/>
							</FormItem>
						) : (
							<div className="p-2">
								<h2 className="text-sm font-medium muted-text">Qty</h2>
								<label className="text-base label-value title-text">
									{quantity}
								</label>
							</div>
						)}
					{mode !== "view" ? (
						<FormItem
							name={[field.name, "poi_cost"]}
							label="Price"
							rules={[requiredField()]}
						>
								<InputNumber
									min={0}
									className="input-field w-full"
								/>
						</FormItem>

							) : (
							<div className="p-2">
								<h2 className="text-sm font-medium muted-text">Price</h2>
								<label className="text-base label-value title-text">
									{currency} {" "}
									{cost.toLocaleString()}
								</label>
							</div>

							)}

					<div>
						<p className="text-sm muted-text mb-1">
							Total Amount
						</p>

						<div className="border rounded-xl px-4 py-3 bg-gray-50 dark:bg-white/20">
							<h2 className="text-2xl font-bold title-text">
								{currency}{" "}
								{total.toLocaleString(undefined, {
									minimumFractionDigits: 2,
									maximumFractionDigits: 2,
								})}
							</h2>
						</div>
					</div>

					{mode !== "view" && (
						<Button
							danger
							block
							onClick={() => remove(field.name)}
						>
							Remove Item
						</Button>
					)}
				</div>
			</div>
		</Card>
	);
};

export default PurchaseOrderItemForm;